import { schema } from "normalizr";

const LanguageSchema = new schema.Entity("languages");
const LanguageArraySchema = new schema.Array(LanguageSchema);

export { LanguageSchema, LanguageArraySchema };